var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Vue, Component, Watch } from "vue-facing-decorator";
import { EventTypesClient, LookupsClient, AlarmDefinitionsClient, AlarmsClient, EventTypeModel, CreateEventTypeCommand, UpdateEventTypeCommand, GetAlarmDefinitionsInUseQuery } from "@/app/api/battery-portal-api";
import ContactsVue from "@/app/vues/components/contacts.vue";
import { Notifier } from "@/common/utils/notifier";
import { Alert } from "@/common/utils/alert";
import { HttpHelper } from "@/app/utils/http-helper";
import { TextHelper } from "@/app/utils/text-helper";
import RouteNames from "@/app/router/routes";
import "@/app/component-hooks";
import { useForm } from 'vee-validate';
import * as yup from 'yup';
const eventTypeClient = new EventTypesClient(window.apiUrl);
const lookupClient = new LookupsClient(window.apiUrl);
const alarmsClient = new AlarmsClient(window.apiUrl);
const alarmDefinitionsClient = new AlarmDefinitionsClient(window.apiUrl);
let EventTypeVue = class EventTypeVue extends Vue {
    constructor() {
        super(...arguments);
        // simpletons
        this.companyId = 0;
        this.eventTypeId = 0;
        this.loaded = false;
        this.working = false;
        this.attemptedSave = false;
        this.lastAlarmSelected = 0;
        // Filters
        this.alarmTypeId = null;
        this.severityFilterKey = 0;
        // components
        this.msg = new Alert();
        // models
        this.eventType = new EventTypeModel();
        // arrays
        this.eventScopes = [];
        this.alarmTypes = [];
        this.alarmSeverities = [];
        this.alarmDefinitions = [];
        this.alarmDefinitionIdsInUse = [];
        this.showOnlyAlarmsSelected = false;
    }
    created() {
        this.companyId = parseInt(this.$route.params.companyId) || 0;
        this.eventTypeId = parseInt(this.$route.params.id) || 0;
        this.get();
        this.getLookups();
    }
    ;
    mounted() {
    }
    ;
    // get
    get() {
        if (this.isNewEventType) {
            let eventType = new EventTypeModel();
            eventType.init({});
            this.map(eventType);
            this.eventType.enabled = true;
            this.loaded = true;
            return;
        }
        this.working = true;
        eventTypeClient
            .get(this.eventTypeId)
            .then(response => {
            if (!response) {
                this.$router.push({ name: RouteNames.Home });
                return;
            }
            this.loaded = true;
            this.map(response);
            this.setValues({
                name: this.eventType.eventTypeName,
                scope: this.eventScope,
                timeWindows: this.eventType.timeWindowMinutes
            });
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    getLookups() {
        let promises = [
            lookupClient
                .getAlarmScopes()
                .then(response => {
                this.eventScopes = response
                    .map(eventScope => {
                    return {
                        value: eventScope.alarmScopeId,
                        text: eventScope.alarmScopeName
                    };
                });
                if (this.eventType.groupByScopeId) {
                    this.setFieldValue("scope", this.eventScope);
                }
            }),
            alarmsClient
                .getAlarmTypes()
                .then(response => {
                this.alarmTypes = response;
            }),
            alarmsClient
                .getAlarmSeverities()
                .then(response => {
                let alarmSeverities = (response || []).map((item) => {
                    return {
                        value: item.alarmSeverityId,
                        text: item.alarmSeverityName || "",
                        selected: true
                    };
                });
                this.alarmSeverities = alarmSeverities;
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            }),
            alarmDefinitionsClient
                .getList()
                .then(response => {
                this.alarmDefinitions = response;
            }),
            eventTypeClient
                .getAlarmDefinitionsInUse(new GetAlarmDefinitionsInUseQuery({ companyId: this.companyId, eventTypeId: this.eventTypeId }))
                .then(response => {
                this.alarmDefinitionIdsInUse = response;
            })
        ];
        Promise.all(promises);
    }
    ;
    map(eventType) {
        this.eventType = eventType;
        this.eventType.companyId = this.companyId;
        this.eventType.alarmDefinitionIds = this.eventType.alarmDefinitionIds || new Array();
        this.eventType.contactIds = this.eventType.contactIds || new Array();
        this.eventType.contactGroupIds = this.eventType.contactGroupIds || new Array();
    }
    ;
    // set
    save() {
        var _a, _b;
        if (this.working)
            return;
        if (Number(this.eventType.minEventDuration) > Number(this.eventType.timeWindowMinutes)) {
            Notifier.onWarning("Minimum Alarm Duration cannot be greater than Time Window!");
            return;
        }
        if ((this.eventType.sendEmail || this.eventType.sendSms) &&
            (((_a = this.eventType.contactIds) === null || _a === void 0 ? void 0 : _a.length) || 0) <= 0 && (((_b = this.eventType.contactGroupIds) === null || _b === void 0 ? void 0 : _b.length) || 0) <= 0) {
            Notifier.onWarning("Select at least one Contact or Contact Group in the list!");
            return;
        }
        const handleSubmitAction = this.handleSubmit(() => {
            let promise = () => {
                return this.isNewEventType
                    ? eventTypeClient.add(new CreateEventTypeCommand({ requestModel: this.eventType }))
                    : eventTypeClient.update(this.eventType.eventTypeId, new UpdateEventTypeCommand({ requestModel: this.eventType }));
            };
            promise()
                .then(response => {
                this.eventTypeId = response;
                Notifier.onOk();
                this.get();
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        }, () => {
            Notifier.onError("Please check that you have correctly entered all details.");
        });
        handleSubmitAction();
    }
    ;
    archive() {
        if (this.working || this.isNewEventType)
            return;
        this.$confirmModal.show("Are you sure that you want to archive this event type?", { title: "Please confirm" })
            .then((value) => {
            if (!value)
                return;
            this.working = true;
            eventTypeClient
                .delete(this.eventType.eventTypeId)
                .then(() => {
                this.eventType.whenDeleted = new Date();
                Notifier.onOk(`Event Type ${this.eventType.eventTypeName} has been successfully archived.`);
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        });
    }
    ;
    restore() {
        if (this.working || this.isNewEventType)
            return;
        this.working = true;
        eventTypeClient
            .restore(this.eventType.eventTypeId)
            .then(() => {
            this.eventType.whenDeleted = undefined;
            Notifier.onOk(`Event Type ${this.eventType.eventTypeName} has been successfully restored.`);
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    goBack() {
        this.$router.back();
    }
    ;
    validate() {
        this.msg.clear();
        let valid = this.isValid;
        if (!valid)
            this.msg.error("Please complete all required fields.");
        return valid;
    }
    ;
    onScopeChanged() {
        if (this.working)
            return;
        this.alarmTypeId = null;
        this.unselectAllAlarmDefinitions();
    }
    onSendNotificationsOnFirstAlarmChange() {
        if (!this.eventType.sendNotificationsOnFirstAlarm)
            this.eventType.minEventDuration = 0;
    }
    selectSeverity(severity) {
        this.ensureOneSeveritySelected(!severity.selected, severity);
    }
    ;
    getAlarmSeverityFilter(item) {
        return 'severity-' + item.value + this.severityFilterKey;
    }
    ensureOneSeveritySelected(checked, severity) {
        if (this.numberOfSeletedAlarmSeverities <= 1) {
            severity.selected = true;
            this.severityFilterKey++;
            return;
        }
        severity.selected = checked;
    }
    ;
    selectAllAlarmDefinitions() {
        this.eventType.alarmDefinitionIds = this.alarmDefinitionOptionsVisible.filter(item => !this.isAlarmInUse(item)).map(item => item.value);
    }
    unselectAllAlarmDefinitions() {
        this.eventType.alarmDefinitionIds = [];
    }
    // computed
    get pageTitle() {
        return this.isNewEventType ? "New Event Type" : this.eventTypeTitle;
    }
    ;
    get eventTypeTitle() {
        if (!this.eventType)
            return "";
        return TextHelper.getRecordTitle(this.eventType.eventTypeName || "", this.isEventTypeArchived);
    }
    ;
    get isNewEventType() {
        return !this.eventTypeId;
    }
    ;
    get isEventTypeArchived() {
        return this.eventType.whenDeleted != null;
    }
    ;
    get isEventTypeNameValid() {
        return this.attemptedSave && !this.eventType.eventTypeName;
    }
    ;
    get isEventScopeValid() {
        return this.attemptedSave && !this.eventType.groupByScopeId;
    }
    ;
    get isValid() {
        return !this.isEventTypeNameValid && this.isEventScopeValid;
    }
    ;
    get eventScope() {
        return this.eventScopes.filter(item => {
            return item.value == this.eventType.groupByScopeId;
        })[0] || null;
    }
    ;
    set eventScope(item) {
        this.setFieldValue("scope", item);
        if (!this.eventType)
            return;
        this.eventType.groupByScopeId = item.value;
    }
    ;
    get alarmType() {
        return this.alarmTypeOptionsVisible.filter(item => {
            return item.value == this.alarmTypeId;
        })[0] || null;
    }
    ;
    set alarmType(item) {
        this.alarmTypeId = item === null || item === void 0 ? void 0 : item.value;
    }
    ;
    get selectPlaceholder() {
        return TextHelper.emptyListItemName;
    }
    ;
    get alarmTypeOptionsVisible() {
        var alarmTypeVisible = (item) => {
            if (!this.eventType.groupByScopeId)
                return false;
            var validScopes = [];
            switch (this.eventType.groupByScopeId) {
                case 1: // String
                    validScopes.push(1);
                    validScopes.push(2);
                    break;
                case 4: // System
                    validScopes.push(1);
                    validScopes.push(2);
                    validScopes.push(4);
                    break;
                default:
                    validScopes.push(this.eventType.groupByScopeId);
                    break;
            }
            return validScopes.includes(item.alarmScopeId);
        };
        function compare(a, b) {
            if (a.text < b.text) {
                return -1;
            }
            if (a.text > b.text) {
                return 1;
            }
            return 0;
        }
        var alarmTypes = this.alarmTypes
            .filter(item => alarmTypeVisible(item))
            .map(alarmType => {
            return {
                value: alarmType.alarmTypeId,
                text: `${alarmType.scopeName}: ${alarmType.alarmTypeName}`
            };
        })
            .sort(compare);
        alarmTypes = [{ value: null, text: `All alarm types` }].concat(alarmTypes);
        return alarmTypes;
    }
    get numberOfSeletedAlarmSeverities() {
        return this.alarmSeverities.filter(alarmSeverity => alarmSeverity.selected).length;
    }
    ;
    get alarmSeverityOptionText() {
        var _a;
        if (this.numberOfSeletedAlarmSeverities == this.alarmSeverities.length)
            return `All severities`;
        if (this.numberOfSeletedAlarmSeverities != 1)
            return this.alarmSeverities.filter(alarmSeverity => alarmSeverity.selected).map(alarmSeverity => alarmSeverity.text).join(", ");
        return (_a = this.alarmSeverities.filter(alarmSeverity => alarmSeverity.selected)[0]) === null || _a === void 0 ? void 0 : _a.text;
    }
    ;
    get alarmDefinitionOptionsVisible() {
        var filterAlarmTypeByScope = (item) => {
            if (!this.eventType.groupByScopeId)
                return false;
            var validScopes = [];
            switch (this.eventType.groupByScopeId) {
                case 1: // String
                    validScopes.push(1);
                    validScopes.push(2);
                    break;
                case 4: // System
                    validScopes.push(1);
                    validScopes.push(2);
                    validScopes.push(4);
                    break;
                default:
                    validScopes.push(this.eventType.groupByScopeId);
                    break;
            }
            return validScopes.includes(item.alarmScopeId);
        };
        function compare(a, b) {
            if (a.text < b.text) {
                return -1;
            }
            if (a.text > b.text) {
                return 1;
            }
            return 0;
        }
        var alarmTypeIds = this.alarmTypeId ? [this.alarmTypeId] : this.alarmTypes
            .filter(item => filterAlarmTypeByScope(item))
            .map(item => item.alarmTypeId);
        var alarmSeverityIds = this.alarmSeverities.filter(item => item.selected).map(item => item.value);
        return this.alarmDefinitions
            .filter(item => alarmTypeIds.includes(item.alarmTypeId) && alarmSeverityIds.includes(item.alarmSeverityId))
            .filter(item => !this.showOnlyAlarmsSelected || this.isAlarmSelected({
            value: item.alarmDefinitionId,
            text: item.alarmDefinitionName
        }))
            .map(alarmDefinition => {
            return {
                value: alarmDefinition.alarmDefinitionId,
                text: `${alarmDefinition.alarmSeverityName}: ${alarmDefinition.alarmDefinitionName}`
            };
        })
            .sort(compare);
    }
    isAlarmSelected(item) {
        try {
            return this.eventType.alarmDefinitionIds != null && this.eventType.alarmDefinitionIds.includes(item.value);
        }
        catch (ex) {
            console.error(ex);
        }
        return false;
    }
    isAlarmInUse(item) {
        return this.alarmDefinitionIdsInUse.includes(item.value);
    }
    getAlarmDefnitionTitle(item) {
        return this.isAlarmInUse(item) ? "Alarm Definition has been assigned to another Event Type. It can only be assigned to one Event Type." : "";
    }
    selectAlarm(item, event) {
        var _a;
        if (!this.eventType.alarmDefinitionIds || this.isAlarmInUse(item))
            return;
        if (event.shiftKey) {
            (_a = document.getSelection()) === null || _a === void 0 ? void 0 : _a.removeAllRanges();
            var data = this.alarmDefinitionOptionsVisible;
            var previousIdx = this.lastAlarmSelected != 0 ? data.findIndex(option => option.value == this.lastAlarmSelected) : 0;
            var currentIdx = data.findIndex(option => option.value == item.value);
            if (previousIdx >= 0 && currentIdx >= 0 && previousIdx != currentIdx) {
                let startIdx = Math.min(previousIdx, currentIdx);
                let endIdx = Math.max(previousIdx, currentIdx);
                for (var i = startIdx; i <= endIdx; i++) {
                    if (data[i]) {
                        if (!this.isAlarmInUse(data[i]) && !this.eventType.alarmDefinitionIds.includes(data[i].value))
                            this.eventType.alarmDefinitionIds.push(data[i].value);
                    }
                }
            }
        }
        else {
            var idx = this.eventType.alarmDefinitionIds.indexOf(item.value);
            if (idx >= 0)
                this.eventType.alarmDefinitionIds = this.eventType.alarmDefinitionIds.filter(id => id != item.value);
            else
                this.eventType.alarmDefinitionIds.push(item.value);
            this.lastAlarmSelected = item.value;
        }
    }
    selectedAlarmsCount() {
        var _a, _b, _c, _d, _e, _f;
        var count = (_c = (_b = (_a = this.eventType) === null || _a === void 0 ? void 0 : _a.alarmDefinitionIds) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0;
        this.showOnlyAlarmsSelected = count == 0 ? false : this.showOnlyAlarmsSelected;
        return (_f = (_e = (_d = this.eventType) === null || _d === void 0 ? void 0 : _d.alarmDefinitionIds) === null || _e === void 0 ? void 0 : _e.length) !== null && _f !== void 0 ? _f : 0;
    }
};
__decorate([
    Watch("eventType.groupByScopeId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], EventTypeVue.prototype, "onScopeChanged", null);
__decorate([
    Watch("eventType.sendNotificationsOnFirstAlarm"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], EventTypeVue.prototype, "onSendNotificationsOnFirstAlarmChange", null);
EventTypeVue = __decorate([
    Component({
        name: "EventTypeVue",
        components: {
            ContactsVue
        },
        setup() {
            const { errors, handleSubmit, defineInputBinds, defineComponentBinds, setFieldValue, setValues } = useForm({
                validationSchema: yup.object({
                    name: yup.string().trim().required(),
                    scope: yup.object().listOptionRequired(),
                    timeWindow: yup.number().integer().min(0).max(1440),
                    minEventDuration: yup.number().integer().min(0).max(60),
                }),
            });
            const nameVal = defineInputBinds('name');
            const scopeVal = defineComponentBinds('scope');
            const timeWindowVal = defineComponentBinds('timeWindow');
            const minEventDurationVal = defineComponentBinds('minEventDuration');
            return {
                errors,
                handleSubmit,
                setFieldValue,
                setValues,
                nameVal,
                scopeVal,
                timeWindowVal,
                minEventDurationVal
            };
        }
    })
], EventTypeVue);
export default EventTypeVue;
